import React, { useState, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import SignIn from "./SignIn";
import SignUp from "./SignUp";

const Auth = ({ isOpen, setSignIn, setSignUp, closeAuth }) => {
  const [page, setPage] = useState("signUp");

  const ref = useRef(null);

  return <CSSTransition nodeRef={ref} in={isOpen} timeout={400} classNames="modal" unmountOnExit>
    <div className="login" ref={ref}>
      <button className="login__close" onClick={closeAuth} />
      <div className="login__container">
        <div className="login__inner">
          <div className="login__logo">
            <svg width="80" height="80">
              <rect width="80" height="80" fill="#181818" fillRule="nonzero" rx="40"></rect>
              <path fill="#2d68ff" d="M57.5 36.9979c4.1421 0 7.5-3.3575 7.5-7.4991s-3.3579-7.499-7.5-7.499-7.5 3.3574-7.5 7.499 3.3579 7.4991 7.5 7.4991z"></path>
              <path fill="#f8f8f8" d="M58 40.9528l-1 .0448c-6.0751 0-11-4.9242-11-10.9986 0-2.0074.5378-3.8891 1.4772-5.5091l-4.3235-2.3517c-1.9664-1.0697-4.341-1.0697-6.3074 0l-11.4 6.201C23.3222 29.4946 22 31.719 22 34.1369v11.7359c0 2.418 1.3222 4.6424 3.4463 5.7977l11.4 6.2011c1.9664 1.0696 4.341 1.0696 6.3074 0l11.4-6.2011C56.6778 50.5152 58 48.2908 58 45.8728v-4.92z"></path>
            </svg>
          </div>
          {page === "signUp" && (
            <>
              <h1 className="login__title">Create new account</h1>
              <SignUp
                setSignUp={setSignUp}
                goToSignIn={() => setPage("signIn")}
              />
            </>
          )}
          {page === "signIn" && (
            <>
              <h1 className="login__title">Log in to your account</h1>
              <SignIn
                setSignIn={setSignIn}
                goToSignUp={() => setPage("signUp")}
              />
            </>
          )}
        </div>
      </div>
      <div className="login__copyright">© 2024, UI8 LLC.</div>
    </div>
  </CSSTransition>
};

export default Auth;
